import { Link } from "react-router-dom";
import { CONTACT_EMAIL, WHATSAPP_DISPLAY, waLink } from "../../layout/shared";
import { RECYCLING_IMAGES } from "../../data/recyclingImages";
import { MaterialPhoto } from "./MaterialPhoto";

export const PhotoEnquiry = ({ id, title, intro, details, message, quoteTo }) => (
  <section data-testid={`${id}-photos`} className="bg-white py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-2 items-start gap-10 lg:gap-16">
      <MaterialPhoto image={RECYCLING_IMAGES.sendPhotos} testId={`${id}-send-photos-image`} caption="Photograph each material stream separately, including the quantity and condition." />
      <div className="min-w-0">
        <h2 data-testid={`${id}-photos-heading`} className="font-display font-bold text-base md:text-lg text-[#024120]">{title}</h2>
        <p className="mt-4 mb-6 text-sm md:text-base leading-relaxed text-[#4A4A4A]">{intro}</p>
        <ul data-testid={`${id}-photo-details`} className="space-y-3 text-sm md:text-base text-[#4A4A4A] leading-relaxed">
          {details.map((detail, i) => <li key={detail} data-testid={`${id}-photo-details-${i + 1}`} className="pl-4 border-l-2 border-[#46B649]">{detail}</li>)}
        </ul>
        <div className="mt-8 flex flex-col gap-3">
          <a data-testid={`${id}-whatsapp-contact`} href={waLink(message)} target="_blank" rel="noreferrer" className="bg-[#FF6600] hover:bg-[#E55A00] font-bold px-5 py-4 text-center text-sm transition-colors">
            Send photos on WhatsApp<span className="block mt-1 font-normal">{WHATSAPP_DISPLAY}</span>
          </a>
          <Link data-testid={`${id}-photo-quote-link`} to={quoteTo} className="border border-[#024120] hover:bg-[#024120] hover:text-white text-[#024120] font-bold px-5 py-3 text-sm text-center transition-colors">Get a quote</Link>
        </div>
        <a data-testid={`${id}-email-contact`} href={`mailto:${CONTACT_EMAIL}`} className="inline-block mt-6 max-w-full break-words text-sm text-[#024120] underline underline-offset-4 hover:text-[#a83f00] transition-colors">{CONTACT_EMAIL}</a>
      </div>
    </div>
  </section>
);